const ModalsFactory = require("modals/factory");
define(function (require) {
    'use strict';

    var _ = require('underscore');
    var Marionette = require('marionette');
    var ModelModal = require('modals/_base/model/model');

    var ModalHeader = require('modals/_base/view/header');
    var ModalBody = require('modals/_base/view/body');
    var ModalFooter = require('modals/_base/view/footer');

    var template = require('text!modals/_base/template/modal.tpl').default;

    require('arctic.modal');


    return Marionette.LayoutView.extend({
        //destroyImmediate: true,

        template: template,
        className: 'hide',

        regions: {
            modalHeader: "#modal-header",
            modalBody: "#modal-body",
            modalFooter: "#modal-footer"
        },

        parentEvents: {},
        bodyOverflow: {},
        newEvents: {}, // события детей
        events: function () {
            return _.extend({}, this.parentEvents, this.newEvents);
        },

        initialize: function (options) {
            app.States.modalIsOpen = false;
            this.model = new ModelModal(options);
            this.on('render', this.afterRender);
        },

        afterRender: function () {
            var _this = this;

            this.showHeader();
            this.showBody();
            this.showFooter();

            var closeOnEsc = true;
            if(typeof this.model.get('closeOnEsc') !== 'undefined'){
                closeOnEsc = !!this.model.get('closeOnEsc');
            }

            var modalEl = this.$el.find('#modal-window').arcticmodal({
                closeOnOverlayClick: false, //(this.model.get('preventOverlayClick') || app.intro) ? false : true,
                closeOnEsc : closeOnEsc && !app.intro,
                openEffect: {
                    type: 'none',
                    speed: 400
                },
                closeEffect: {
                    type: 'none',
                    speed: 400
                },
                beforeOpen: function (inst, el) {
                    var $box = $('.arcticmodal-container > table > tbody > tr > td');
                    if (app.States.modalIsOpen) {
                        _this.hide();
                    }

                    if (_this.model.get('width')) {
                        //$box.css('width', _this.model.get('width'))
                        //    .removeClass('arcticmodal-container_i2');
                        el.css('width', _this.model.get('width'));
                    }

                    if (_this.model.get('modalClass')) {
                        $box.addClass(_this.model.get('modalClass'));
                    }

                    _this.bodyOverflow.overflow = $('body').css('overflow');
                    _this.bodyOverflow.overflowX = $('body').css('overflowX');
                    _this.bodyOverflow.overflowY = $('body').css('overflowY');
                    _this.model.set('curElement', el);
                    if (!_this.model.get('preventOverlayClick')) {
                        el.closest('.arcticmodal-container').on('mousedown', function(event) {
                            if (!$(event.target).closest('.box-modal').length) {
                                _this.hide();
                            }
                        })
                    }
                },
                beforeClose: function() {
                    $('.webui-popover').hide();
                    _this.destroy();
                },
                afterClose: function () {
                    app.Vents.trigger('modal:close');
                    // for calendar
                    app.States.modalIsOpen = false;
                    if (typeof app.Models.EditTask != 'undefined') {
                        app.Models.EditTask.trigger('offMark');
                    }

                    $('body').css(_this.bodyOverflow);
                },
                overlay: this.model.get('overlay') || {}
            });
            this.setElement(modalEl);
        },

        showHeader: function () {
            if (this.model.get('show_header')) {
                this.modalHeader.show(new ModalHeader({model: this.model}));
            }
        },

        showBody: function () {
            this.modalBody.show(new ModalBody({model: this.model}));

        },

        showFooter: function () {
            if (this.model.get('show_footer')) {
                this.modalFooter.show(new ModalFooter({model: this.model}));
            }
        },

        hide: function () {
            // debugger;

            app.States.modalIsOpen = false;

            var curElement = this.model.get('curElement');
            curElement.arcticmodal('close');
        }
    });

});
